import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-[1280px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-book-open-line text-xl text-primary-500"></i>
                </div>
                <span className="font-heading text-lg font-bold text-primary-600">女神漫画网</span>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                女神漫画网为您提供蜜桃少年高清漫画全集免费阅读下拉式服务，海量正版漫画资源，高清画质极速加载，随时随地畅享阅读乐趣。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">
                <a href="/category/shaonian" className="hover:text-primary-600 transition-colors cursor-pointer">漫画分类</a>
              </h4>
              <div className="grid grid-cols-2 gap-2">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">热门推荐</h4>
              <div className="space-y-2">
                <Link to="/article/1" className="block text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">蜜桃少年</Link>
                <Link to="/article/12" className="block text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">龙族传说</Link>
                <Link to="/article/9" className="block text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">长安幻夜</Link>
                <Link to="/article/5" className="block text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">仙路争锋</Link>
                <Link to="/article/3" className="block text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">花间少年</Link>
              </div>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">
                <Link to="/about" className="hover:text-primary-600 transition-colors cursor-pointer">关于我们</Link>
              </h4>
              <div className="space-y-2">
                <p className="text-sm text-foreground-600">联系邮箱：contact@nvshenmanhua.com</p>
                <p className="text-sm text-foreground-600">客服QQ：1234567890</p>
                <p className="text-sm text-foreground-600">工作时间：周一至周日 9:00-21:00</p>
              </div>
              <div className="flex items-center gap-3 mt-4">
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer" aria-label="QQ">
                  <i className="ri-qq-line"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">
              &copy; 2026 女神漫画网 版权所有 | 蜜桃少年漫画高清全集免费阅读
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">用户协议</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">隐私政策</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">版权声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}